document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('[data-floating-coupon]');
  if (!wrapper) return;

  var STORAGE_KEY = 'floating_coupon_dismissed';

  if (sessionStorage.getItem(STORAGE_KEY) === '1') {
    wrapper.style.display = 'none';
    return;
  }

  var pill = wrapper.querySelector('[data-fc-pill]');
  var pillOpen = wrapper.querySelector('[data-fc-pill-open]');
  var dismissBtn = wrapper.querySelector('[data-fc-dismiss]');
  var overlay = wrapper.querySelector('[data-fc-overlay]');
  var popup = wrapper.querySelector('[data-fc-popup]');
  var popupClose = wrapper.querySelector('[data-fc-popup-close]');
  var copyBtn = wrapper.querySelector('[data-fc-copy]');
  var copiedEl = wrapper.querySelector('[data-fc-copied]');

  var couponCode = wrapper.getAttribute('data-coupon-code') || '';
  var copiedTimer = null;

  function showPopup() {
    pill.classList.add('is-hidden');
    popup.classList.add('is-active');
    overlay.classList.add('is-active');
    copiedEl.classList.remove('is-active');
  }

  function closePopup() {
    popup.classList.remove('is-active');
    overlay.classList.remove('is-active');
    pill.classList.remove('is-hidden');
  }

  function showCopied() {
    popup.classList.remove('is-active');
    overlay.classList.remove('is-active');
    pill.classList.add('is-hidden');
    copiedEl.classList.add('is-active');

    if (copiedTimer) clearTimeout(copiedTimer);
    copiedTimer = setTimeout(function () {
      copiedEl.classList.remove('is-active');
      wrapper.style.display = 'none';
      sessionStorage.setItem(STORAGE_KEY, '1');
    }, 4000);
  }

  function dismissCoupon() {
    sessionStorage.setItem(STORAGE_KEY, '1');
    wrapper.style.display = 'none';
  }

  pillOpen.addEventListener('click', showPopup);

  dismissBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    dismissCoupon();
  });

  popupClose.addEventListener('click', closePopup);
  overlay.addEventListener('click', closePopup);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-active')) {
      closePopup();
    }
  });

  copyBtn.addEventListener('click', function () {
    navigator.clipboard.writeText(couponCode).then(function () {
      showCopied();
    });
  });

  var hideClasses = ['drawer-open', 'overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet'];

  function checkBodyClasses() {
    var bodyClasses = document.body.classList;
    var shouldHide = false;
    for (var i = 0; i < hideClasses.length; i++) {
      if (bodyClasses.contains(hideClasses[i])) {
        shouldHide = true;
        break;
      }
    }
    if (shouldHide) {
      wrapper.classList.add('is-hidden');
    } else {
      wrapper.classList.remove('is-hidden');
    }
  }

  new MutationObserver(checkBodyClasses).observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  var header = document.querySelector('header');
  if (header) {
    new MutationObserver(function () {
      if (header.classList.contains('menu-open')) {
        wrapper.classList.add('is-hidden');
      } else {
        checkBodyClasses();
      }
    }).observe(header, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  checkBodyClasses();
});
